import { queryOptions } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { indexInvoiceStatus } from "~/modules/billing/api/invoiceStatus/invoiceStatusApiDispatchers.ts";

export const invoiceStatusQueries = {
	baseKey: ["invoice-statuses"],
	all: () =>
		queryOptions({
			queryKey: [...invoiceStatusQueries.baseKey, "all"],
			queryFn: () => indexInvoiceStatus().then(getDataFromResponse),
		}),
};